export function getExternalIndexHref (baseUrl: string, localePath: (route: string) => string): string {
  return `${baseUrl}${localePath('index')}`
}

export function getExternalCompareMobileHref (baseUrl: string, localePath: (route: string) => string, providerSlug?: string): string {
  const url = `${baseUrl}${localePath('compare-mobile')}`
  return providerSlug ? `${url}?providers=${providerSlug}` : url
}

export function getExternalCompareHomeHref (baseUrl: string, localePath: (route: string) => string, providerSlug?: string): string {
  const url = `${baseUrl}${localePath('compare-home')}`
  return providerSlug ? `${url}?providers=${providerSlug}` : url
}

/**
 * Формирует внешнюю ссылку на детальную страницу мобильного предложения
 */
export function getExternalCompareMobileSlugHref (baseUrl: string, localePath: (route: string | { name: string, params: any }) => string, slug: string): string {
  return `${baseUrl}${localePath({ name: 'compare-mobile-slug', params: { slug } })}`
}

/**
 * Формирует внешнюю ссылку на детальную страницу домашнего предложения
 */
export function getExternalCompareHomeSlugHref (baseUrl: string, localePath: (route: string | { name: string, params: any }) => string, slug: string): string {
  return `${baseUrl}${localePath({ name: 'compare-home-slug', params: { slug } })}`
}

/**
 * Формирует внешнюю ссылку на детальную страницу пакетного предложения
 */
export function getExternalCompareBundleSlugHref (baseUrl: string, localePath: (route: string | { name: string, params: any }) => string, slug: string): string {
  return `${baseUrl}${localePath({ name: 'compare-bundle-slug', params: { slug } })}`
}
